const arrayMove = (arr, fromIndex, toIndex) => {
	const element = arr[fromIndex]
	arr.splice(fromIndex, 1)
	arr.splice(toIndex, 0, element)
	return arr
}

export default arrayMove



// WEBPACK FOOTER //
// ./src/utilities/arrayMove.js